import React, { Component } from 'react';
import { useState } from 'react';
import Swal from 'sweetalert2';


function UserName(){
    const [usering , setUsering] = useState('')
    const style = window.localStorage.getItem("Name") === "Default-Page" ? "block" : "none" 
    // window.localStorage.setItem("Name" , usering)
    const handleClick = (e) =>{
        e.preventDefault() ;
        if(usering === ''){
            window.localStorage.setItem("Name" , "Default-Page");
            Swal.fire({
                icon: "error" , 
                text : "You cannot access without Entering a Name" ,
                // title: "!!الاسم يانجوميه ؟",
                timer : 2500 ,
                timerProgressBar : true ,
                showConfirmButton: false
            })
        }
        else if(usering === ' '){
            window.localStorage.setItem("Name" , "Default-Page");
            Swal.fire({
                icon: "error" , 
                text :"الاسم يانجوميه معلش تعالي ع نفسك" ,
                // title: "!!الاسم يانجوميه ؟",
                timer : 2500 ,
                timerProgressBar : true ,
                showConfirmButton: false
            })
        }else if(usering.length > 0 &&usering.length <= 8){
            window.localStorage.setItem("Name" , "Default-Page");
            Swal.fire({
                imageUrl : "https://thumbs.gfycat.com/LividFlashyApatosaur-max-1mb.gif" ,
                text : "Your Name should have at least 8 characters to access"
            })
        }else{
            window.localStorage.setItem("Name" , usering);
            window.location.reload()
        }
    }

    return ( 
        <React.Fragment>
            <div className="formImportName" style={{display : style}}>
                <form>
                    <div className="content">
                        <label>Enter <span style={{color : "#FFB100"}}>Special</span> Name :</label>
                        <input type="text" dir='auto' value={usering} onChange={(e) => setUsering(e.target.value)} placeholder='ex : AlMkkawy@847'/>
                        <button onClick={(e) => handleClick(e)}>OK</button>
                    </div>
                </form>
            </div>
        </React.Fragment>
    );
}

export default UserName;